    var ErrorScreenService = function ($timeout) {
        var currentSubscriberId = -1;
        var subscribers = [];
        //subscribe
        //
        //@param {function} - handler
        //
        //@return {number} - current subscriber id
        //
        //@description
        //Subscribes listener on error notification.
        function subscribe(handler) {
            //check if handler is a function
            if (typeof handler !== 'function') {
                throw new Error('Handler has to be a function');
            };
            //create new subscriber
            var subscriber = {
                //handlerId: ++currentSubscriberId,
                id: ++currentSubscriberId,
                handler: handler
            };
            //add subscriber into collection
            subscribers.push(subscriber);
            //return new subscriber id
            return subscriber.id;
        };
        //unsubscribe
        //
        //@param {number} - id
        //
        //@return {boolean} - true if unsubscribe was successful
        //
        //@description
        //Unsubscribes listener with given id
        function unsubscribe(id) {
            var initialLength = subscribers.length;
            //exclude subscriber with given id from the collection
            subscribers = subscribers.filter(function (el) {
                return el.id !== id;
            });
            //check if the subscriber was excluded from the collection
            return initialLength !== subscribers.length;
        };
        //error
        //
        //@param {boolean} - show
        //@param {number} - error id (see errors.js constants file for details)
        //
        //@description
        //Notifies all subscribers about error event.
        function error(show, errorId, options) {
            $timeout(function () {
                subscribers.forEach(function (el) {
                    el.handler.call(null, show, errorId, options);
                });
            });
        }
        //factory methods
        return {
            subscribe: subscribe,
            unsubscribe: unsubscribe,
            error: error
        }
    };
    ErrorScreenService.$inject = ['$timeout'];

    module.exports = ErrorScreenService;
